import { PDFDownloadLink } from "@react-pdf/renderer";
import { Button } from "@material-ui/core";
import { userHasSomePermissions } from "../permissionsUtils";
import { PermissionIdEnum } from "../../util/types/permissions/permissionIdEnum";

export const DownloadButton = ({ documentComponent, fileName, dataLoading = false }) => {
  return (
    <>
      {userHasSomePermissions([PermissionIdEnum.Super, PermissionIdEnum.CysRiskAssessmentPdf]) && (
        <PDFDownloadLink document={documentComponent} fileName={fileName}>
          {({ blob, url, loading, error }) => {
            if (error) {
              return "There is no pdf file available for now.";
            } else
              return (
                <Button disabled={loading} variant="outlined" color="secondary" size="small">
                  {loading || dataLoading ? "Loading document..." : "Download PDF"}
                </Button>
              );
          }}
        </PDFDownloadLink>
      )}
    </>
  );
};
